/**
 * Created by khanhduong on 10/30/17.
 */
import * as utils from '../functions/utils';
import * as messageUtils from '../functions/messageUtils';
import * as constants from '../constants/constants';
import { ICountry, IMainPhoto, IMemberTypeTitle } from 'redhotpie-shared-lib/interfaces/IUser';
import { IDetailInfo, IMappedValue, IRecurringStatus, ITempInfo, LocationInfo } from 'redhotpie-shared-lib/types/login';

// interface MappedPhoto {
//   classification: number;
//   fullUrl: string;
//   height: number;
//   isPublic: boolean;
//   isUserImage: boolean;
//   photoID: number;
//   thumbUrl: string;
//   width: number;
//   imageType: string;
// }

// interface MemberTypeTitle {
//   abbr: string;
//   plural: string;
//   singular: string;
// }

export default class User {
  created_at: string;
  userId: number;
  xmppId: string;
  isDiamond?: boolean;
  memberLevel: string;
  memberLevelValue: number;
  memberLevelExpiry: string;
  activeProducts: string[];
  memberType: number;
  verificationState: string;
  displayName: string;
  emailAddress: string;
  usernameRejected: boolean;
  recurringStatus: IRecurringStatus;
  detailInfo: IDetailInfo;
  locationInfo: LocationInfo;
  tempInfo: ITempInfo;
  old: number;
  online: boolean;
  isMatch: boolean;
  memberTypeTitle: IMemberTypeTitle;
  classIfication: number;
  location: string;
  isUserImage: boolean;
  country: ICountry;
  isCouple: boolean;
  ageTitle: string;
  matching?: unknown[];

  constructor() {
    this.created_at = '';
    this.userId = 0;
    this.xmppId = '';
    this.memberLevel = '';
    this.memberLevelValue = 0;
    this.memberLevelExpiry = '';
    this.activeProducts = [];
    this.memberType = constants.MEMBER_TYPES.GUEST;
    this.verificationState = '';
    this.displayName = '';
    this.emailAddress = '';
    this.usernameRejected = false;
    this.recurringStatus = {
      isRecurring: false,
      isRecurringCancelPending: false,
      lastPaymentProvider: '',
      rebillCost: -1,
    };
    this.detailInfo = {
      birthDate: '',
      birthDate2: '',
      bodyHair: 0,
      bodyHair2: 0,
      bodyType: 0,
      bodyType2: 0,
      circumcised: 0,
      circumcised2: 0,
      cupSize: 0,
      cupSize2: 3,
      drinking: 0,
      drinking2: 0,
      endowmentLength: 0,
      endowmentLength2: 0,
      endowmentThickness: 0,
      endowmentThickness2: 0,
      eyeColour: 0,
      eyeColour2: 0,
      fantasyActivity: 0,
      fantasyLocation: 0,
      fantasyMustHave: 0,
      fetishInterest: 0,
      fetishInterestValues: [],
      generalInterest: 0,
      generalInterestValues: [],
      hairColour: 0,
      hairColour2: 0,
      hairLength: 0,
      hairLength2: 0,
      height: 0,
      height2: 0,
      intention: 0,
      dealBreaker: 0,
      dealBreakerValues: [],
      intentionValues: [],
      intimatePiercing: 0,
      intimatePiercing2: 0,
      introBody: '',
      introTitle: '',
      levelOfParticipation: 0,
      levelOfParticipation2: 0,
      maritalStatus: 0,
      maritalStatus2: 0,
      mood: 0,
      myLooks: 0,
      myLooks2: 0,
      personality: 0,
      personality2: 0,
      postCodeAllID: 0,
      pubicHair: 0,
      pubicHair2: 0,
      race: 0,
      race2: 0,
      safeSex: 0,
      safeSex2: 0,
      seekingBody: '',
      seekingMaritalStatus: '',
      seekingOldest: 0,
      seekingStateID: 0,
      seekingTypes: 0,
      seekingTypeValues: [],
      seekingYoungest: 0,
      sexualOrientation: 0,
      sexualOrientation2: 0,
      sexualPersonality: 0,
      sexualPersonality2: 0,
      sexualPreference: 0,
      sexualInterest: 0,
      sexualInterestValues: [],
      sexualPreferenceValues: [],
      smoking: 0,
      smoking2: 0,
      memberTypeChangePending: false,
      memberTypeChangeType: '',
    };
    this.locationInfo = {
      country: {
        code: '',
        countryID: '',
        GoogleMapPlacesId: '',
        StateName: '',
        LocationType: 'state',
      },
      state: {
        code: '',
        countryID: '',
        GoogleMapPlacesId: '',
        StateName: '',
        LocationType: 'state',
      },
      suburb: {
        code: '',
        countryID: '',
        GoogleMapPlacesId: '',
        StateName: '',
        LocationType: 'state',
      },
    };
    this.tempInfo = {
      introBody: '',
      introTitle: '',
      isIntroBodyRejected: false,
      isIntroTitleRejected: false,
      isProcessed: false,
      isSeekingBodyRejected: false,
      seekingBody: '',
    };
    this.old = 0;
    this.online = false;
    this.isMatch = false;
    this.memberTypeTitle = {
      abbr: '',
      plural: '',
      singular: '',
    };
    this.classIfication = 0;
    this.location = '';
    this.isUserImage = false;
    this.country = {
      id: -1,
      name: '',
      googleMapId: '',
      code: '',
    };
    this.isCouple = false;
    this.ageTitle = '';
  }

  static mappingObjectCustom(_user: any): User {
    if (_user) {
      let user = Object.assign(new User(), _user);
      let sexualInterestValues: IMappedValue[] = [];
      if (_user.DetailInfo && _user.DetailInfo.SexualInterestValues) {
        if (_user.AccountInfo.MemberType === 4 || _user.AccountInfo.MemberType === 16 || _user.AccountInfo.MemberType === 32) {
          sexualInterestValues = User.mappingPropertySexualInterestCouple(_user.DetailInfo.SexualInterestValues);
        } else {
          sexualInterestValues = User.mappingPropertySexualInterestSingle(_user.DetailInfo.SexualInterestValues);
        }
      }
      // Account Info
      user.userId = parseInt(_user.AccountInfo.MemberID || _user.AccountInfo.UserID || '0');
      user.xmppId = messageUtils.removePrefixAndSuffix(_user.AccountInfo.MemberID || _user.AccountInfo.UserID || '');
      user.isDiamond = _user.AccountInfo.IsDiamond;
      user.memberLevel = (_user.AccountInfo && _user.AccountInfo.MemberLevel && _user.AccountInfo.MemberLevel.MemberLevel) || '';
      user.memberLevelValue = (_user.AccountInfo && _user.AccountInfo.MemberLevel && _user.AccountInfo.MemberLevel.MemberLevelValue) || 0;
      user.activeProducts = (_user.AccountInfo && _user.AccountInfo.MemberLevel && _user.AccountInfo.MemberLevel.ActiveProducts) || [];
      user.memberLevelExpiry = _user.AccountInfo.MemberLevel.MemberLevelExpiry;
      user.displayName = _user.AccountInfo.UserName || _user.AccountInfo.Username || _user.AccountInfo.Handle || 'Guest';
      user.usernameRejected = _user.AccountInfo.UsernameRejected || false;
      user.memberType = _user.AccountInfo.MemberType;
      user.verificationState = _user.AccountInfo.VerificationState || '';
      user.emailAddress = _user.AccountInfo.EmailAddress || '';
      // Detail Info
      user.ageTitle = _user.DetailInfo?.AgeTitle || '';
      user.detailInfo.birthDate = _user.DetailInfo ? _user.DetailInfo.Birthdate || '' : '';
      user.detailInfo.birthDate2 = _user.DetailInfo ? _user.DetailInfo.Birthdate2 || '' : '';
      user.detailInfo.bodyHair = _user.DetailInfo ? _user.DetailInfo.BodyHair || 0 : 0;
      user.detailInfo.bodyHair2 = _user.DetailInfo ? _user.DetailInfo.BodyHair2 || 0 : 0;
      user.detailInfo.bodyType = _user.DetailInfo ? _user.DetailInfo.BodyType || 0 : 0;
      user.detailInfo.bodyType2 = _user.DetailInfo ? _user.DetailInfo.BodyType2 || 0 : 0;
      user.detailInfo.circumcised = _user.DetailInfo ? _user.DetailInfo.Circumcised || 0 : 0;
      user.detailInfo.circumcised2 = _user.DetailInfo ? _user.DetailInfo.Circumcised2 || 0 : 0;
      user.detailInfo.cupSize = _user.DetailInfo ? _user.DetailInfo.Cupsize || 0 : 0;
      user.detailInfo.cupSize2 = _user.DetailInfo ? _user.DetailInfo.Cupsize2 || 0 : 0;
      user.detailInfo.drinking = _user.DetailInfo ? _user.DetailInfo.Drinking || 0 : 0;
      user.detailInfo.drinking2 = _user.DetailInfo ? _user.DetailInfo.Drinking2 || 0 : 0;
      user.detailInfo.endowmentLength = _user.DetailInfo ? _user.DetailInfo.EndowmentLength || 0 : 0;
      user.detailInfo.endowmentLength2 = _user.DetailInfo ? _user.DetailInfo.EndowmentLength2 || 0 : 0;
      user.detailInfo.endowmentThickness = _user.DetailInfo ? _user.DetailInfo.EndowmentThickness || 0 : 0;
      user.detailInfo.endowmentThickness2 = _user.DetailInfo ? _user.DetailInfo.EndowmentThickness2 || 0 : 0;
      user.detailInfo.eyeColour = _user.DetailInfo ? _user.DetailInfo.EyeColour || 0 : 0;
      user.detailInfo.eyeColour2 = _user.DetailInfo ? _user.DetailInfo.EyeColour2 || 0 : 0;
      user.detailInfo.fantasyActivity = _user.DetailInfo ? _user.DetailInfo.FantasyActivity || 0 : 0;
      user.detailInfo.fantasyLocation = _user.DetailInfo ? _user.DetailInfo.FantasyLocation || 0 : 0;
      user.detailInfo.fantasyMustHave = _user.DetailInfo ? _user.DetailInfo.FantasyMustHave || 0 : 0;
      user.detailInfo.fetishInterest = _user.DetailInfo ? _user.DetailInfo.FetishInterest || 0 : 0;
      // values mapping
      user.detailInfo.generalInterest = _user.DetailInfo ? _user.DetailInfo.GeneralInterest || 0 : 0;
      user.detailInfo.generalInterestValues =
        _user.DetailInfo && _user.DetailInfo.GeneralInterestValues ? User.mappingProperty(_user.DetailInfo.GeneralInterestValues) : [];
      user.detailInfo.seekingTypeValues =
        _user.DetailInfo && _user.DetailInfo.SeekingTypeValues ? User.mappingProperty(_user.DetailInfo.SeekingTypeValues) : [];
      user.detailInfo.sexualPreferenceValues =
        _user.DetailInfo && _user.DetailInfo.SexualPreferenceValues
          ? User.mappingPropertyPreference(_user.DetailInfo.SexualPreferenceValues)
          : [];
      user.detailInfo.sexualInterestValues = sexualInterestValues;
      user.detailInfo.fetishInterestValues =
        _user.DetailInfo && _user.DetailInfo.FetishInterestValues ? User.mappingProperty(_user.DetailInfo.FetishInterestValues) : [];
      user.detailInfo.intentionValues =
        _user.DetailInfo && _user.DetailInfo.IntentionValues ? User.mappingProperty(_user.DetailInfo.IntentionValues) : [];
      // TODO update Deal Breaker
      user.detailInfo.dealBreakerValues = [];
      user.memberTypeTitle =
        _user.DetailInfo && _user.DetailInfo.MemberTypeTitle ? User.mappingMemberTypeTitle(_user.DetailInfo.MemberTypeTitle) : {};
      //
      user.detailInfo.hairColour = _user.DetailInfo ? _user.DetailInfo.HairColour || 0 : 0;
      user.detailInfo.hairColour2 = _user.DetailInfo ? _user.DetailInfo.HairColour2 || 0 : 0;
      user.detailInfo.hairLength = _user.DetailInfo ? _user.DetailInfo.HairLength || 0 : 0;
      user.detailInfo.hairLength2 = _user.DetailInfo ? _user.DetailInfo.HairLength2 || 0 : 0;
      user.detailInfo.height = _user.DetailInfo ? _user.DetailInfo.Height || 0 : 0;
      user.detailInfo.height2 = _user.DetailInfo ? _user.DetailInfo.Height2 || 0 : 0;
      user.detailInfo.intention = _user.DetailInfo ? _user.DetailInfo.Intention || 0 : 0;
      // TODO update Deal Breaker
      user.detailInfo.dealBreaker = _user.DetailInfo ? _user.DetailInfo.DealBreakers || 0 : 0;
      user.detailInfo.intimatePiercing = _user.DetailInfo ? _user.DetailInfo.IntimatePiercing || 0 : 0;
      user.detailInfo.intimatePiercing2 = _user.DetailInfo ? _user.DetailInfo.IntimatePiercing2 || 0 : 0;
      user.detailInfo.introBody = _user.DetailInfo ? _user.DetailInfo.IntroBody || '' : '';
      user.detailInfo.introTitle = _user.DetailInfo ? _user.DetailInfo.IntroTitle || '' : '';
      user.detailInfo.levelOfParticipation = _user.DetailInfo ? _user.DetailInfo.LevelOfParticipation || 0 : 0;
      user.detailInfo.levelOfParticipation2 = _user.DetailInfo ? _user.DetailInfo.LevelOfParticipation2 || 0 : 0;
      user.detailInfo.maritalStatus = _user.DetailInfo ? _user.DetailInfo.MaritalStatus || 0 : 0;
      user.detailInfo.maritalStatus2 = _user.DetailInfo ? _user.DetailInfo.MaritalStatus2 || 0 : 0;
      user.detailInfo.mood = _user.DetailInfo ? _user.DetailInfo.Mood || 0 : 0;
      user.detailInfo.myLooks = _user.DetailInfo ? _user.DetailInfo.Mylooks || 0 : 0;
      user.detailInfo.myLooks2 = _user.DetailInfo ? _user.DetailInfo.Mylooks2 || 0 : 0;
      user.detailInfo.personality = _user.DetailInfo ? _user.DetailInfo.Personality || 0 : 0;
      user.detailInfo.personality2 = _user.DetailInfo ? _user.DetailInfo.Personality2 || 0 : 0;
      user.detailInfo.postCodeAllID = _user.DetailInfo ? _user.DetailInfo.PostCodeAllID || 0 : 0;
      user.detailInfo.pubicHair = _user.DetailInfo ? _user.DetailInfo.Pubichair || 0 : 0;
      user.detailInfo.pubicHair2 = _user.DetailInfo ? _user.DetailInfo.Pubichair2 || 0 : 0;
      user.detailInfo.race = _user.DetailInfo ? _user.DetailInfo.Race || 0 : 0;
      user.detailInfo.race2 = _user.DetailInfo ? _user.DetailInfo.Race2 || 0 : 0;
      user.detailInfo.safeSex = _user.DetailInfo ? _user.DetailInfo.Safesex || 0 : 0;
      user.detailInfo.safeSex2 = _user.DetailInfo ? _user.DetailInfo.Safesex2 || 0 : 0;
      user.detailInfo.seekingBody = _user.DetailInfo ? _user.DetailInfo.SeekingBody || '' : '';
      user.detailInfo.seekingMaritalStatus = _user.DetailInfo ? _user.DetailInfo.SeekingMaritalStatus || 0 : 0;
      user.detailInfo.seekingOldest = _user.DetailInfo ? _user.DetailInfo.SeekingOldest || 0 : 0;
      user.detailInfo.seekingStateID = _user.DetailInfo ? _user.DetailInfo.SeekingStateID || 0 : 0;
      user.detailInfo.seekingTypes = _user.DetailInfo ? _user.DetailInfo.SeekingTypes || 0 : 0;
      user.detailInfo.seekingYoungest = _user.DetailInfo ? _user.DetailInfo.SeekingYoungest || 0 : 0;
      user.detailInfo.sexualOrientation = _user.DetailInfo ? _user.DetailInfo.SexualOrientation || 0 : 0;
      user.detailInfo.sexualOrientation2 = _user.DetailInfo ? _user.DetailInfo.SexualOrientation2 || 0 : 0;
      user.detailInfo.sexualPersonality = _user.DetailInfo ? _user.DetailInfo.SexualPersonality || 0 : 0;
      user.detailInfo.sexualPersonality2 = _user.DetailInfo ? _user.DetailInfo.SexualPersonality2 || 0 : 0;
      user.detailInfo.sexualPreference = _user.DetailInfo ? _user.DetailInfo.SexualPreference || 0 : 0;
      user.detailInfo.sexualInterest = _user.DetailInfo ? _user.DetailInfo.SexualInterest || 0 : 0;
      user.detailInfo.smoking = _user.DetailInfo ? _user.DetailInfo.Smoking || 0 : 0;
      user.detailInfo.smoking2 = _user.DetailInfo ? _user.DetailInfo.Smoking2 || 0 : 0;

      user.detailInfo.showMutualInterestsOnly = _user.DetailInfo?.ShowMutualInterestsOnly || false;
      user.detailInfo.memberTypeChangePending = _user.DetailInfo?.MemberTypeChangePending || false;
      user.detailInfo.memberTypeChangeType = _user.DetailInfo?.MemberTypeChangeType || '';
      //Location Info
      user.locationInfo.country.code = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.Code : '';
      user.locationInfo.country.countryID = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.CountryID : null;
      user.locationInfo.country.GoogleMapPlacesId =
        _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.GoogleMapPlacesId : '';
      user.locationInfo.country.StateName = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.Name : '';
      user.locationInfo.country.LocationType = 'Country';
      user.country.code = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.Code : '';
      user.country.countryID = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.CountryID : null;
      user.country.id = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.CountryID : null;
      user.country.GoogleMapPlacesId = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.GoogleMapPlacesId : '';
      user.country.googleMapId = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.GoogleMapPlacesId : '';
      user.country.StateName = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.Name : '';
      user.country.name = _user.LocationInfo && _user.LocationInfo.Country ? _user.LocationInfo.Country.Name : '';
      user.country.LocationType = 'Country';
      user.locationInfo.state.code = _user.LocationInfo && _user.LocationInfo.State ? _user.LocationInfo.State.Code : '';
      user.locationInfo.state.countryID = _user.LocationInfo && _user.LocationInfo.State ? _user.LocationInfo.State.CountryID : '';
      user.locationInfo.state.GoogleMapPlacesId =
        _user.LocationInfo && _user.LocationInfo.State ? _user.LocationInfo.State.GoogleMapPlacesId : '';
      user.locationInfo.state.StateName = _user.LocationInfo && _user.LocationInfo.State ? _user.LocationInfo.State.Name : '';
      user.locationInfo.state.LocationType = 'State';
      user.locationInfo.suburb.code = _user.LocationInfo && _user.LocationInfo.Suburb ? _user.LocationInfo.Suburb.Code : '';
      user.locationInfo.suburb.countryID = _user.LocationInfo && _user.LocationInfo.Suburb ? _user.LocationInfo.Suburb.CountryID : '';
      user.locationInfo.suburb.GoogleMapPlacesId =
        _user.LocationInfo && _user.LocationInfo.Suburb ? _user.LocationInfo.Suburb.GoogleMapPlacesId : '';
      user.locationInfo.suburb.StateName = _user.LocationInfo && _user.LocationInfo.Suburb ? _user.LocationInfo.Suburb.Name : '';
      user.locationInfo.suburb.LocationType = 'Suburb';

      user.tempInfo.introBody = _user.TempInfo ? _user.TempInfo.IntroBody || '' : '';
      user.tempInfo.introTitle = _user.TempInfo ? _user.TempInfo.IntroTitle || '' : '';
      user.tempInfo.isIntroBodyRejected = _user.TempInfo ? _user.TempInfo.IsIntroBodyRejected || false : false;
      user.tempInfo.isIntroTitleRejected = _user.TempInfo ? _user.TempInfo.IsIntroTitleRejected || false : false;
      user.tempInfo.isProcessed = _user.TempInfo ? _user.TempInfo.IsProcessed || false : false;
      user.tempInfo.isSeekingBodyRejected = _user.TempInfo ? _user.TempInfo.IsSeekingBodyRejected || false : false;
      user.tempInfo.seekingBody = _user.TempInfo ? _user.TempInfo.SeekingBody || false : false;

      user.old = _user.Age1 || 0;
      user.location =
        _user.LocationInfo && _user.LocationInfo.Suburb && _user.LocationInfo.State && _user.LocationInfo.Country
          ? `${_user.LocationInfo.Suburb.Name}, ${_user.LocationInfo.State.Name}, ${_user.LocationInfo.Country.Name} `
          : '';
      user.online = _user.IsOnline || false;
      user.matching = _user.MatchingInterests || [];
      user.isCouple = !!(_user.AccountInfo.MemberType === 4 || _user.AccountInfo.MemberType === 16 || _user.AccountInfo.MemberType === 32);
      user.recurringStatus.isRecurring =
        (_user.AccountInfo.MemberLevel.RecurringStatus && _user.AccountInfo.MemberLevel.RecurringStatus.IsRecurring) || false;
      user.recurringStatus.isRecurringCancelPending =
        (_user.AccountInfo.MemberLevel.RecurringStatus && _user.AccountInfo.MemberLevel.RecurringStatus.IsRecurringCancelPending) || false;
      user.recurringStatus.lastPaymentProvider =
        (_user.AccountInfo.MemberLevel.RecurringStatus && _user.AccountInfo.MemberLevel.RecurringStatus.LastPaymentProvider) || '';
      user.recurringStatus.rebillCost =
        (_user.AccountInfo.MemberLevel.RecurringStatus &&
          _user.AccountInfo.MemberLevel.RecurringStatus.RebillCost &&
          utils.formatNumberShowNDecimalPlaces(_user.AccountInfo.MemberLevel.RecurringStatus.RebillCost, 2)) ||
        -1;
      user = utils.cleanObjectKeys(Object.keys(new User()), user) as User;
      return user;
    }
    return new User();
  }

  static mappingPhoto(_obj: {
    Classification?: number;
    FullUrl?: string;
    Height?: number;
    IsPublic?: boolean;
    ImageType?: string;
    PhotoID?: number;
    ThumbUrl?: string;
    Width?: number;
  }): IMainPhoto {
    const obj: IMainPhoto = {
      classification: 0,
      fullUrl: '',
      height: 0,
      isPublic: false,
      isUserImage: false,
      photoID: 0,
      thumbUrl: '',
      width: 0,
      imageType: '',
    };
    if (_obj) {
      obj.classification = _obj.Classification || 0;
      obj.fullUrl = _obj.FullUrl || '';
      obj.height = _obj.Height || 0;
      obj.isPublic = _obj.IsPublic || false;
      obj.isUserImage = _obj.ImageType !== constants.NO_PHOTO;
      obj.photoID = _obj.PhotoID || 0;
      obj.thumbUrl = _obj.ThumbUrl || '';
      obj.width = _obj.Width || 0;
      obj.imageType = _obj.ImageType || '';
    }
    return obj;
  }

  static mappingValue(_obj: { IsMatch?: boolean; Text?: string; Value?: number }): IMappedValue {
    const obj: IMappedValue = {
      id: 0,
      value: null,
      active: true,
      label: '',
      isMatch: false,
    };
    if (_obj) {
      obj.isMatch = _obj.IsMatch || false;
      obj.label = _obj.Text || '';
      obj.id = _obj.Value || 0;
    }
    return obj;
  }

  static mappingProperty(data: Array<{ IsMatch?: boolean; Text?: string; Value?: number }>): IMappedValue[] {
    const _data: IMappedValue[] = [];
    if (data.length > 0) {
      data.forEach(_obj => {
        _data.push(User.mappingValue(_obj));
      });
    }
    return _data;
  }

  static mappingValuePreference(_obj: { IsMatch?: boolean; Text?: string; Value?: number }): IMappedValue {
    const obj: IMappedValue = {
      id: 0,
      listId: 70,
      value: null,
      active: true,
      label: '',
      isMatch: false,
    };
    if (_obj) {
      obj.isMatch = _obj.IsMatch || false;
      obj.label = _obj.Text || '';
      obj.id = _obj.Value || 0;
    }
    return obj;
  }

  static mappingPropertyPreference(data: Array<{ IsMatch?: boolean; Text?: string; Value?: number }>): IMappedValue[] {
    const _data: IMappedValue[] = [];
    if (data.length > 0) {
      data.forEach(_obj => {
        const obj = User.mappingValuePreference(_obj);
        _data.push(obj);
      });
    }
    return _data;
  }

  //
  static mappingValueSexualInterestCouple(_obj: { IsMatch?: boolean; Text?: string; Value?: number }): IMappedValue {
    const obj: IMappedValue = {
      id: 0,
      listId: 72,
      value: null,
      active: true,
      label: '',
      isMatch: false,
    };
    if (_obj) {
      obj.isMatch = _obj.IsMatch || false;
      obj.label = _obj.Text || '';
      obj.id = _obj.Value || 0;
    }
    return obj;
  }

  static mappingPropertySexualInterestCouple(data: Array<{ IsMatch?: boolean; Text?: string; Value?: number }>): IMappedValue[] {
    const _data: IMappedValue[] = [];
    if (data.length > 0) {
      data.forEach(_obj => {
        const obj = User.mappingValueSexualInterestCouple(_obj);
        _data.push(obj);
      });
    }
    return _data;
  }

  //
  static mappingValueSexualInterestSingle(_obj: { IsMatch?: boolean; Text?: string; Value?: number }): IMappedValue {
    const obj: IMappedValue = {
      id: 0,
      listId: 71,
      value: null,
      active: true,
      label: '',
      isMatch: false,
    };
    if (_obj) {
      obj.isMatch = _obj.IsMatch || false;
      obj.label = _obj.Text || '';
      obj.id = _obj.Value || 0;
    }
    return obj;
  }

  static mappingPropertySexualInterestSingle(data: Array<{ IsMatch?: boolean; Text?: string; Value?: number }>): IMappedValue[] {
    const _data: IMappedValue[] = [];
    if (data.length > 0) {
      data.forEach(_obj => {
        const obj = User.mappingValueSexualInterestSingle(_obj);
        _data.push(obj);
      });
    }
    return _data;
  }

  static mappingMemberTypeTitle(_obj: { Abbr?: string; Plural?: string; Singular?: string }): IMemberTypeTitle {
    const obj: IMemberTypeTitle = {
      abbr: '',
      plural: '',
      singular: '',
    };
    if (_obj) {
      obj.abbr = _obj.Abbr || '';
      obj.plural = _obj.Plural || '';
      obj.singular = _obj.Singular || '';
    }
    return obj;
  }
}
